import React from "react";
import { CODING_SHOT } from "../lib/helpers";

import ShotItem from "./shot-item";

const ShotList = ({ isFinalized, isCompleted, localeCode, shots, showEcom, roUploadImage, roDeleteImage, roSourceEdit }) => {
    const list = shots.map((view, index) => {
        const key = view.key ? view.key : `${view.shortName}-${index}of${shots.length}`;

        return (
            <ShotItem
                key={`shotItem_${localeCode}_${view.imageViewCode}_${key}`}
                shots={shots}
                view={view}
                isCompleted={isCompleted}
                showEcom={showEcom}
                isFinalized={isFinalized}
                roUploadImage={roUploadImage}
                roDeleteImage={roDeleteImage}
                roSourceEdit={roSourceEdit}
            />
        );
    });

    return (
        <div className="shot-list">
            {list}
            {!isFinalized && (
                <ShotItem
                    key={`shotItem_${localeCode}_coding`}
                    view={{ ...CODING_SHOT }}
                    isPlaceholder={true}
                    roUploadImage={roUploadImage}
                    roDeleteImage={roDeleteImage}
                    roSourceEdit={roSourceEdit}
                />
            )}
        </div>
    );
};

export default ShotList;
